/* global ENV_CONFIG */
import createBiLogger, { VOD_SRC_ID } from 'wix-vod-shared/src/common/bi/create-bi-logger';
import { attempt } from 'shared/utils/attempt';
import events from 'shared/bi/events';
import userTransactions from 'shared/bi/user-transactions';
import { getVisitorId } from './bi-vod';
import WixSDK from 'shared/utils/wix-sdk';

const defaultParams = {
  src: VOD_SRC_ID,
  biToken: attempt(() => WixSDK.Utils.getInstanceValue('biToken')), // same as sid, but we use biToken everywhere
  videoInstanceID: attempt(() => WixSDK.Utils.getInstanceId()),
  compId: attempt(() => WixSDK.Utils.getOrigCompId()) || attempt(() => WixSDK.Utils.getCompId()),
};

export function createVodBiLogger(events, additionalDefaultParams = {}) {
  return createBiLogger({
    events,
    disableBi: ENV_CONFIG.disableBi,
    logBiSend: ENV_CONFIG.logBiSend,
    defaults: {
      ...defaultParams,
      ...additionalDefaultParams,
    },
  });
}


const biLoggerInstance = createVodBiLogger(events, { visitorID: getVisitorId() });

/*
 @param eventName
 @param options
 @param options.previousEventName - use this one for transactions, aka:
 if @previousEventName is set to 'widget.show.requested' event will not fire if previousEvent was not fired yet.
 there is a contract on transaction starting events to end with '.requested'
 */
biLoggerInstance.logWidgetSystem = (eventName, { previousEventName } = {}) => {
  if (userTransactions.isTransaction({ eventName, previousEventName })) {
    const shouldSendEvent = userTransactions.getTransactionResult({ eventName });
    if (!shouldSendEvent) {
      return;
    }
  }

  biLoggerInstance.log('widget-system', {
    eventName,
  });
};

export default biLoggerInstance;



// WEBPACK FOOTER //
// ./src/shared/bi/bi.js